import {
  ElementRef, Output, Directive, AfterViewInit, OnDestroy, EventEmitter, Input, NgZone
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { WindowRef } from '@shared/services';

import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/startWith';
import { setTimeout } from 'timers';

@Directive({
  selector: '[appear]'
})
export class AppearDirective implements AfterViewInit, OnDestroy {
  @Output()
  appear: EventEmitter<void>;

  @Input()
  delay: number;

  elementPos: number;
  elementHeight: number;

  scrollPos: number;
  windowHeight: number;

  subscriptionScroll: Subscription;
  subscriptionResize: Subscription;

  constructor(private element: ElementRef, private windowRef: WindowRef, private zone: NgZone){
    this.appear = new EventEmitter<void>();
    this.delay = 0;
  }

  saveDimensions() {
    this.elementPos = this.getOffsetTop(this.element.nativeElement);
    this.elementHeight = this.element.nativeElement.offsetHeight;
    this.windowHeight = this.windowRef.content.clientHeight;
  }

  saveScrollPos() {
    this.scrollPos = this.windowRef.content.scrollTop;
  }

  getOffsetTop(element: any){
    let offsetTop = element.offsetTop || 0;
    if(element.offsetParent){
      offsetTop += this.getOffsetTop(element.offsetParent);
    }
    return offsetTop;
  }

  checkVisibility(){
    if(this.isVisible()){
      // double check dimensions (due to async loaded contents, e.g. images)
      this.saveDimensions();
      if(this.isVisible()){
        this.unsubscribe();
        this.appear.emit();
      }
    }
  }

  isVisible(){
    return this.scrollPos >= this.elementPos || (this.scrollPos + this.windowHeight) >= (this.elementPos + this.elementHeight);
  }

  subscribe(){
    this.subscriptionScroll = Observable.fromEvent(this.windowRef.content, 'scroll')
      .subscribe(() => {
        this.saveScrollPos();
        this.checkVisibility();
      });
    this.subscriptionResize = Observable.fromEvent(this.windowRef.content, 'resize')
      .subscribe(() => {
        this.saveDimensions();
        this.checkVisibility();
      });
  }

  unsubscribe(){
    if(this.subscriptionScroll){
      this.subscriptionScroll.unsubscribe();
    }
    if(this.subscriptionResize){
      this.subscriptionResize.unsubscribe();
    }
  }

  ngAfterViewInit(){
    this.zone.run(() => {
      setTimeout(() => {
        this.subscribe();
        this.saveDimensions();
      }, this.delay);
    });
  }

  ngOnDestroy(){
    this.unsubscribe();
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/appear/appear.directive.ts